import { LicenceStatus } from 'evee-ui-common/enums';

export default {
  licence: {
    status: LicenceStatus.noLicence,
    countryCode: '',
    number: '',
    verifiedTill: null,
  },
};
